// Suppress TypeScript error for side-effect CSS import when no declaration is present
import React from "react";
import { Link } from "react-router-dom";
// @ts-ignore
import "./ServicesSection.css";

interface ServiceItem {
  icon: string;
  title: string;
  desc: string;
  path: string;
}

const services: ServiceItem[] = [
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/plane-light.svg`,
    title: "Airport Pickup & Drop-Off",
    desc: "Airport pickups and drop-offs. Share your flight number and we'll note terminal instructions and seating options while preparing your estimate.",
    path: "/airports",
  },
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/briefcase.svg`,
    title: "Corporate Transportation",
    desc: "Chauffeured service for executives, meetings, and roadshows. We go over your itinerary, seating needs, and pricing before anything is booked.",
    path: "/services/corporate-travel",
  },
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/wedding.svg`,
    title: "Wedding Transportation",
    desc: "Elegant rides for weddings and special occasions, with car choices and timing arranged around your schedule.",
    path: "/services/weddings",
  },
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/crown-circle.svg`,
    title: "Prom Transportation",
    desc: "Prom rides for groups across NJ, NY, and PA. We cover seating, timing, and pricing ahead of the big night.",
    path: "/services/prom",
  },
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/clock.svg`,
    title: "Hourly Chauffeur Service",
    desc: "Hourly and as-directed service for events, errands, or executive itineraries. Minimums and pricing are outlined before you book.",
    path: "/services/hourly-as-directed",
  },
  {
    icon: `${process.env.PUBLIC_URL}/images/icons/route-03.svg`,
    title: "Point-to-Point",
    desc: "Direct rides between planned destinations, with pricing and car options mapped out for your trip.",
    path: "/services#point-to-point",
  },
];

export default function ServicesSection(): JSX.Element {
  return (
    <section className="services-section py-5" id="services">
      <div className="container">
        <div className="text-center mb-5 gs-anim">
          <span className="section-badge">What We Offer</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-sub">
            From airport runs to wedding celebrations, we provide premium
            luxury transportation for every occasion.
          </p>
        </div>
        <div className="row g-4">
          {services.map((s, i) => (
            <div className="col-sm-6 col-lg-4 gs-anim" key={i}>
              <div className="service-card h-100">
                <div className="service-icon-wrap">
                  <img
                    src={s.icon}
                    alt={s.title}
                    title={s.title}
                    className="service-icon"
                    width="90"
                    height="90"
                    loading="lazy"
                  />
                </div>
                <h3 className="service-title">{s.title}</h3>
                <p className="service-desc">{s.desc}</p>
                <Link
                  to={s.path}
                  className="service-link"
                  title={`Learn more about ${s.title}`}
                >
                  {"Learn More "}
                  <span className="visually-hidden">{`about ${s.title}`}</span>{" "}
                  <i className="fas fa-arrow-right" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
